import { createEvent, restore, sample } from 'effector'
import { DemoContestForm, DemoContestFormResponse } from './types'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'

export const submitCreateDemoContest = createEvent<DemoContestForm>()

export const submitEditDemoContest = createEvent<DemoContestForm>()

export const setDemoContestForm = createEvent<DemoContestForm>()

export const createDemoContest = fx<DemoContestForm, DemoContestFormResponse>({
  method: 'POST',
  url: '/contest',
})

export const editDemoContest = fx<DemoContestForm, DemoContestFormResponse>({
  method: 'PUT',
  url: '/contest',
})

export const $demoContest = restore(setDemoContestForm, {
  name: '',
  contestType: '',
  mtPlatform: '',
  mtInitialBalance: '',
  mtLeverage: '',
  prizeFund: '',
  bonusPercent: '',
  registrationAt: '',
  activatesAt: '',
  resultsAt: '',
  endsAt: '',
  prizes: [],
  currency: '',
  bonusCalculationType: '',
  availableCountries: [],
})

export const $demoContestCreateStatus = restore<{
  id: number
  contestName: string
  isSuccess: boolean
}>(
  createDemoContest.doneData.map((a) => {
    return {
      id: a.body.id,
      contestName: a.body.name,
      isSuccess: true,
    }
  }),
  {
    id: 0,
    contestName: '',
    isSuccess: false,
  },
)

sample({
  clock: submitCreateDemoContest,
  fn: (demoContest) => {
    return {
      url: `/contest`,
      body: { ...demoContest },
    }
  },
  target: createDemoContest,
})

sample({
  clock: submitEditDemoContest,
  source: $params,
  fn: (params, demoContest) => {
    let id
    if (params) {
      id = params.demoContestID
    }

    return {
      url: `/contest/${id}`,
      body: { ...demoContest },
    }
  },
  target: editDemoContest,
})
